import type { Dr15ExtractionResult, UploadedDocument } from '../types';

/**
 * Where "Extract DR-15" lands (B1, docs/core-workflow.md): the journal page with the DR-15 template pre-applied, the
 * upload linked, and the extraction run whose figures fill the form. One helper for every screen that offers the
 * button, because two hand-built URLs had already drifted (one dropped the template, both dropped the figures).
 */
export function dr15JournalHandoffUrl(
  doc: Pick<UploadedDocument, 'clientId' | 'id'>,
  result: Pick<Dr15ExtractionResult, 'extractionRunId'>,
): string {
  const params = new URLSearchParams({
    clientId: doc.clientId,
    sourceDocumentId: doc.id,
    template: 'salesTaxDr15',
  });
  if (result.extractionRunId) params.set('extractionRunId', result.extractionRunId);
  return `/journals?${params.toString()}`;
}
